/**
 * Application Constants
 *
 * Centralized configuration for API URLs and other constants
 */

// API Base URL - Uses VITE_API_URL environment variable
export const API_BASE_URL = import.meta.env.VITE_API_URL?.replace('/api', '') || 'http://localhost:8003';
export const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8003/api';

// Export for backward compatibility
export default {
  API_BASE_URL,
  API_URL,
};
